import PropTypes from 'prop-types';
import React, { useState } from 'react';
import basket_delete_icon from "../../../assets/images/basket-delete.svg";
import delete_icon from "../../../assets/images/delete.svg";
import logo_small from "../../../assets/images/logo-small.svg";
import request_success from "../../../assets/images/request-success.svg";
import request_not_success from "../../../assets/images/request-not-success.svg";
import ua_logo from "../../../assets/images/UA.png";

const Cart = (props) => {

    const [productsArr, setProductsArr] = useState(props.cart_items);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [idToUpdate, setIdToUpdate] = useState(0);

    const [discount, setDiscount] = useState(props.cart_sale);
    const [totalPrice, setTotalPrice] = useState(props.cart_total_price);

    const [successModalOpen, setSuccessModalOpen] = useState(false);
    const [notSuccessModalOpen, setNotSuccessModalOpen] = useState(false);
    const [internationalization, setInternationalization] = useState(props.internationalization);


    const [order, setOrder] = useState({
        email: "",
        name: "",
        phone: "",
        address: "",
        payer_type: "individual",
        payment_system: "cash",
        comment: ""
    })


    const prepareToDelete = (id) => {
        setIdToUpdate(id);
        setDeleteModalOpen(true)
    }

    const updateProductsArr = (data) => {
        let newArr = [];
        if (data.deleted) {
            newArr = productsArr.filter((product,index) => {
                return product.id !== idToUpdate
            })
            setDeleteModalOpen(false);
        } else {
            newArr = productsArr;
            newArr.map((product,index) => {
                if(data.cart_item.id === product.id) {
                    newArr.splice(index, 1, data.cart_item)
                }
            })
        }

        setProductsArr(newArr);
        setTotalPrice(data.cart_total_price);
    }

    const setAmount = (id, side, number) => {
        let amount = number;

        if(side === "reduce") {
            amount = amount -1;
            if(amount < 1) {
                prepareToDelete(id)
                return
            }
        } else {
            amount = amount + 1
        }

        updateProduct(amount, id)
    }

    const addOrderOption = (e, field) => {
        setOrder({...order, [field]: e.target.value})
        console.log(order)
    }

    const updateProduct = (amount, changedAmountProdId) => {
        let productObj = {
            item_id: changedAmountProdId ? changedAmountProdId : idToUpdate,
            amount: amount
        }
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': props.authToken },
            body: JSON.stringify(productObj)
          };

          fetch('/personal/cart', requestOptions)
          .then((response) => {
            if (response.status > 204) {
              throw new Error("Not success");
            }
            return response.json();
          })
          .then((data) => {
            updateProductsArr(data);
          })
          .catch((error) => console.log(error));
    }

    const makeOrder = () => {

        console.log(order)

        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': props.authToken },
            body: JSON.stringify(order)
          };
          let ukr_locale= window.location.href.includes('/ua/') ? 'ua/' : ''
          fetch('/personal/confirm_cart', requestOptions)
          .then((response) => {
            if (response.status > 204) {
                setNotSuccessModalOpen(true);
              throw new Error("Not success");
            } else {
                setSuccessModalOpen(true)
                setTimeout(() => {
                    window.location.href = `/${ukr_locale}`;
                }, 2000)
            }
            return response.json();
          })
          .then((data) => {
          })
          .catch((error) => console.log(error));
    }
  return (
    <section className="basket">
      <div className="flex_container breadCrumbs_container">
        <div className="breadCrumbs">
          {props.breadcrumb.map((breadcrumb_item, index) => {
            return <a href={breadcrumb_item.path} className="breadCrumbs-link"> {breadcrumb_item.name}</a>
          })}
        </div>
      </div>
        <div className="flex_container basket-container">
            <img src={ua_logo} alt="logo" className="top-site-bg_image"></img>
            <div className="basket-title">
                <h1>Корзина</h1>
            </div>

            <div className="basket-main">
                <div className="basket-row basket-row-first">
                    <span className="basket-row-field basket-row-field-num">№</span>
                    <span className="basket-row-field basket-row-field-product">{internationalization.table_name}</span>
                    <span className="basket-row-field basket-row-field-quantity">{internationalization.table_amount}</span>
                    <span className="basket-row-field basket-row-field-itemPrice">{internationalization.table_price}</span>
                    <span className="basket-row-field basket-row-field-generalPrice">{internationalization.table_total_price}</span>
                    <span className="basket-row-field basket-row-field-delete"></span>
                </div>
                {productsArr.map((product,index) => {
                    return  <div className="basket-row">
                                <span className="basket-row-field basket-row-field-num">{index + 1}</span>
                                <a className="basket-row-field basket-row-field-product" href={`/goods/${product.product.category.slug}/${product.product.slug}`}>
                                    <div className="product-img">
                                        <img src={product.product.preview_image_url} alt={product.product.localazed_name} className="product-slide-big"/>
                                    </div>
                                    <div className="product-name">
                                        <span className="product-name-text">{product.product.localazed_name}</span>
                                    </div>
                                </a>
                                <div className="basket-row-field basket-row-field-quantity">
                                    <div className="product-main-info-quantity">
                                        <span className="reduce" onClick={() => setAmount(product.id, "reduce", product.amount)}></span>
                                        <span className="number">{product.amount}</span>
                                        <span className="increase" onClick={() => setAmount(product.id, "increase", product.amount)}></span>
                                    </div>
                                </div>
                                <span className="basket-row-field basket-row-field-itemPrice">{product.product_price} грн</span>
                                <span className="basket-row-field basket-row-field-generalPrice">{product.item_price} грн</span>
                                <span className="basket-row-field basket-row-field-delete" onClick={() => prepareToDelete(product.id)}>
                                    <img src={basket_delete_icon} alt="delete icon" />
                                </span>
                            </div>
                })}

                <div className="basket-bottom">
                    <div className="basket-discount">
                    </div>
                    <div className="basket-bottom-price">
                        <div className="basket-bottom-price-row">
                            <span className="price-text">{internationalization.sale}:</span>
                            <span className="price-num">{discount} грн</span>
                        </div>
                        <div className="basket-bottom-price-row">
                            <span className="price-text">{internationalization.total_price}:</span>
                            <span className="price-num">{totalPrice} грн</span>
                        </div>
                        <button className={`apply-basket green-link ${!props.cart_items.length ? "apply-basket-disabled" : ""}`}>{internationalization.order_button}</button>
                    </div>
                </div>

            </div>

        </div>

        <div className={`main-modal main-modal-delete ${deleteModalOpen ? "main-modal-visible" : ""}`}>
            <div className="main-modal-overlay" onClick={() => setDeleteModalOpen(false)}></div>
            <div className="main-modal-content">
                <span className="main-modal-content-close" onClick={() => setDeleteModalOpen(false)}><img src={delete_icon}></img></span>
                <h5 className="main-modal-content-title">{internationalization.delete_product_modal_title}</h5>
                <p className="main-modal-content-text">{internationalization.delete_product_modal_subtitle}</p>
                <div className="main-modal-delete-btns">
                    <button className="delete-btn green-link" onClick={() => updateProduct(0)}>{internationalization.delete_product_modal_accept}</button>
                    <button className="cancel-btn green-bordered-link" onClick={() => setDeleteModalOpen(false)}>{internationalization.delete_product_modal_cancel}</button>
                </div>
            </div>
        </div>

        <div className="main-modal main-modal-basket">
            <div className="main-modal-overlay"></div>
            <div className="main-modal-content">
                <span className="main-modal-content-close"><img src={delete_icon} alt="delete icon"></img></span>
                <h5 className="basket-title">{internationalization.accepting_order_modal_title}</h5>
                <p className="basket-text">{internationalization.accepting_order_modal_subtitle}</p>

                <div className="basket-options-block">
                    <h6>{internationalization.accepting_order_modal_payer_description}</h6>
                    <p className="radio-field">
                        <input type="radio" id="test1" name="payer_type" value="individual" onChange={(e) => {addOrderOption(e, "payer_type")}} defaultChecked={true}></input>
                        <label htmlFor="test1">{internationalization.accepting_order_modal_payer_phisical}</label>
                    </p>
                    <p className="radio-field">
                        <input type="radio" id="test2" name="payer_type" value="entity" onChange={(e) => {addOrderOption(e, "payer_type")}}></input>
                        <label htmlFor="test2">{internationalization.accepting_order_modal_payer_yur}</label>
                    </p>
                </div>

                <div className="basket-info">
                    <h6>{internationalization.accepting_order_modal_payer_data}</h6>
                    <input className="basket-info-field" type="text" placeholder={internationalization.accepting_order_modal_payer_fio} onChange={(e) => {addOrderOption(e, "name")}}></input>
                    <input className="basket-info-field" type="email" placeholder="E-mail" onChange={(e) => {addOrderOption(e, "email")}}></input>
                    <input className="basket-info-field" type="number" placeholder={internationalization.accepting_order_modal_payer_phone} onChange={(e) => {addOrderOption(e, "phone")}}></input>
                    <textarea className="basket-info-field basket-info-field-textarea" placeholder={internationalization.accepting_order_modal_payer_address} onChange={(e) => {addOrderOption(e, "address")}}></textarea>
                </div>

                <div className="basket-options-block">
                    <h6>{internationalization.accepting_order_modal_payment_type}</h6>
                    <p className="radio-field">
                        <input type="radio" id="test3" name="payment_system" value="cash" onChange={(e) => {addOrderOption(e, "payment_system")}} defaultChecked={true}></input>
                        <label htmlFor="test3">{internationalization.accepting_order_modal_payment_nal}</label>
                    </p>
                    <p className="radio-field">
                        <input type="radio" id="test4" name="payment_system" value="nalozheniy" onChange={(e) => {addOrderOption(e, "payment_system")}}></input>
                        <label htmlFor="test4">{internationalization.accepting_order_modal_payment_nalozh}</label>
                    </p>
                </div>

                <div className="comment basket-info">
                    <div className="comment-top">
                        <h6>{internationalization.accepting_order_modal_comment} <span>{internationalization.accepting_order_modal_comment_type}</span></h6>
                    </div>
                    <textarea className="basket-info-field basket-info-field-textarea" placeholder={internationalization.accepting_order_modal_comment_placeholder} onChange={(e) => {addOrderOption(e, "comment")}}></textarea>
                </div>

                <button className="green-link" onClick={() => {makeOrder()}}>{internationalization.order_button}</button>
            </div>
        </div>

        <div className={`main-modal main-modal-info ${successModalOpen ? "main-modal-visible" : ""}`}>
            <div className="main-modal-overlay" onClick={() => setSuccessModalOpen(false)}></div>
            <div className="main-modal-content">
                <span className="main-modal-content-close" onClick={() => setSuccessModalOpen(false)}><img src={delete_icon} alt="delete icon"></img></span>
                <img className="main-modal-content-bg" src={logo_small} alt="delete icon"></img>
                <img className="main-modal-content-icon" src={request_success} alt="success icon"></img>
                <h5 className="main-modal-content-title">{internationalization.success_request}</h5>
            </div>
        </div>

        <div className={`main-modal main-modal-info ${notSuccessModalOpen ? "main-modal-visible" : ""}`}>
            <div className="main-modal-overlay" onClick={() => setNotSuccessModalOpen(false)}></div>
            <div className="main-modal-content">
                <span className="main-modal-content-close" onClick={() => setNotSuccessModalOpen(false)}><img src={delete_icon} alt="delete icon"></img></span>
                <img className="main-modal-content-bg" src={logo_small} alt="logo small icon"></img>
                <img className="main-modal-content-icon" src={request_not_success} alt="not success icon"></img>
                <h5 className="main-modal-content-title">{internationalization.failure_request}</h5>
            </div>
        </div>

    </section>
  );
};

export default Cart;
